<template>
  <div class="column is-3">
    <div class="is-border is-radius-large has-bg-white">
      <aside class="menu menu-guide">
        <div class="column">
          <strong>
            <router-link to="/">Accueil</router-link>
          </strong>
        </div>
        <div class="column has-bg-light is-radius-top-left-large is-radius-top-right-large"><strong>Rubriques</strong></div>
        <ul>
          <li @click='changeMenu(rubric.redirectId)' :key="rubric.redirectId" v-for="rubric in authorizedRubrics">
          <router-link :to="{ name: 'Rubric', params: {rubricId: rubric.redirectId}}">{{rubric.name}}</router-link>
            <ul v-if="currentMenu === rubric.redirectId" class="is-size-6 has-bg-light is-padding-top-small is-padding-bottom-small">
              <li :key="page.redirectId" v-for="page in rubric.pages">
                <router-link :to="{ name: 'Page', params: { pageId: page.redirectId,rubricId : rubric.redirectId }}">{{ page | hide }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </aside>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Navbar',
  data () {
    return {
      currentMenu: null
    }
  },
  computed: {
    ...mapGetters(['authorizedRubrics'])
  },
  methods: {
    changeMenu (topicid) {
      this.currentMenu = topicid
    }
  }
}
</script>
